
export default function loginCheckout(groups, members) {
  // Update token

  window.localStorage.setItem('groups', JSON.stringify(groups));
  window.localStorage.setItem('members', JSON.stringify(members));
}
